// PreciosTabXL - Sprint 44 Fase 3 Vista 3.
// Tab "Precios y costos": precio_venta + costo_ultimo editables con
// XLMoneyInput (number output). costo_real y costo_promedio read-only
// porque se calculan desde Importacion USA / Kardex.
//
// [FIX bug heredado] Texto "Proximamente (Sprint 24)" en costo_promedio
// era obsoleto (S29 ya implemento kardex NIIF). Actualizado para reflejar
// la realidad.
import { useEffect } from 'react';
import { ensureKeyframes, injectCSS } from '../../../design/motion';
import XLMoneyInput from '../../../components/xl/XLMoneyInput';
import { fmtMoney } from '../../../utils/money';

const CSS_ID = 'xl-prod-precios-css';
const CSS = `
.xl-form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  font-family: var(--xl-font-sans);
}
@media (max-width: 720px) { .xl-form-grid { grid-template-columns: 1fr } }

.xl-ro {
  display: flex; flex-direction: column; gap: 4px;
}
.xl-ro__label {
  font-size: 12px; font-weight: 500;
  color: var(--xl-color-text-secondary);
}
.xl-ro__value {
  padding: 10px 12px;
  background: var(--xl-color-surface-alt);
  border: 1px solid var(--xl-color-border);
  border-radius: var(--xl-radius-md);
  font-family: var(--xl-font-mono);
  font-size: 14px;
  color: var(--xl-color-text-muted);
  cursor: not-allowed;
  text-align: right;
}
.xl-ro__hint {
  font-size: 11px;
  color: var(--xl-color-text-muted);
  line-height: 1.4;
}
`;

function parseNum(v) {
  if (v === '' || v === null || v === undefined) return null;
  const n = Number(v);
  return Number.isNaN(n) ? null : n;
}

export default function PreciosTabXL({ form, set, errors = {} }) {
  useEffect(() => { ensureKeyframes(); injectCSS(CSS_ID, CSS); }, []);

  const vPrecio = parseNum(form.precio_venta);
  const vCosto  = parseNum(form.costo_ultimo);

  const fmtRO = (v) => {
    if (v === null || v === undefined || v === '') return '\u2014';
    const n = Number(v);
    if (Number.isNaN(n)) return '\u2014';
    return fmtMoney(n, 'COP');
  };

  return (
    <div className="xl-form-grid">
      <XLMoneyInput
        label="Precio de venta"
        moneda="COP"
        value={vPrecio}
        onChange={(n) => set('precio_venta', n == null ? '' : n)}
        error={errors.precio_venta}
      />
      <XLMoneyInput
        label="Costo ultimo"
        moneda="COP"
        value={vCosto}
        onChange={(n) => set('costo_ultimo', n == null ? '' : n)}
        error={errors.costo_ultimo}
        hint="Se actualiza automaticamente al distribuir costos en Importacion USA."
      />
      <div className="xl-ro">
        <label className="xl-ro__label">Costo real (aterrizado)</label>
        <div className="xl-ro__value" aria-readonly="true">
          {fmtRO(form.costo_real)}
        </div>
        <div className="xl-ro__hint">
          Calculado en el proceso de distribucion de costos (Sprint 21). Solo lectura.
        </div>
      </div>
      <div className="xl-ro">
        <label className="xl-ro__label">Costo promedio</label>
        <div className="xl-ro__value" aria-readonly="true">
          {fmtRO(form.costo_promedio)}
        </div>
        <div className="xl-ro__hint">
          Calculado desde Kardex NIIF (Sprint 29). Solo lectura.
        </div>
      </div>
    </div>
  );
}
